namespace Matrix.Workflow {
    export interface WorkflowMapBatchDeleteRequest extends Serenity.ServiceRequest {
        MapIdList?: number[];
    }
}
